import React, { useState } from 'react';
import { Mail, Check, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useApp } from '../context/AppContext';
import { toast } from 'sonner';

const NewsletterSignup = ({ variant = 'inline' }) => {
  const { API, t } = useApp();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error(t('enter_valid_email'));
      return;
    }
    
    setLoading(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      
      if (response.data.already_subscribed) {
        toast.info(response.data.message);
      } else {
        toast.success(response.data.message);
        setSubscribed(true);
      }
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.detail || t('subscription_failed'));
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className={`${variant === 'footer' ? '' : 'glass rounded-xl p-6'}`}>
        <div className="flex items-center justify-center gap-3 text-green-500">
          <Check size={24} />
          <span>{t('thanks_subscribing')}</span>
        </div>
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#57534E]" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('your_email')}
            className="w-full pl-10 pr-4 py-3 bg-[#121212] border border-[#2C1B18] rounded-lg text-white placeholder-[#57534E] focus:outline-none focus:border-[#D4AF37] transition-colors"
            disabled={loading}
            data-testid="newsletter-email-input"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="btn-primary whitespace-nowrap"
          data-testid="newsletter-submit-btn"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : t('subscribe')}
        </button>
      </form>
    );
  }

  // Full variant (for dedicated section)
  return (
    <div className="glass rounded-xl p-6 md:p-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-3 bg-[#D4AF37]/10 rounded-full">
          <Mail size={24} className="text-[#D4AF37]" />
        </div>
        <div>
          <h3 className="font-heading text-lg text-white">{t('newsletter')}</h3>
          <p className="text-[#A8A29E] text-sm">{t('exclusive_offers')}</p>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t('your_email')}
          className="input-luxury w-full"
          disabled={loading}
        />
        <button
          type="submit"
          disabled={loading}
          className="btn-primary w-full flex items-center justify-center gap-2"
        >
          {loading ? (
            <Loader2 size={18} className="animate-spin" />
          ) : (
            <>
              <Mail size={18} />
              {t('subscribe_newsletter')}
            </>
          )}
        </button>
      </form>
      
      <p className="text-[#57534E] text-xs mt-4 text-center">
        {t('unsubscribe_anytime')}
      </p>
    </div>
  );
};

export default NewsletterSignup;
